export const defaultFontSize = '1.6rem';

export const colorPrimaryDark1 = '4, 6, 36';
export const colorPrimaryDark1Hex = '#040624';
export const colorPrimaryDark2 = '32, 31, 91';
export const colorPrimaryDark2Hex = '#201F5B';
export const colorPrimary = '#4475F2';
export const colorGrayDark = '#777';
export const colorGrayText = '#6d6d70';
export const colorPrimaryText = '#0A6CFF';
export const colorWhite = '#fff';
export const colorWhite2 = '#F0F0F0';
export const colorBlack = '#000';
export const colorBrownText = '#665000';
export const colorPrimaryButton = '#d7e7ff';